import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import { Story } from '../../../../../services';

interface UsePostInStoryIdDefaultArgs {
  postInStories: Story[];
  postInStorageKey: string;
  cardStoryId?: number;
}

export const usePostInStoryIdDefault = ({
  postInStories,
  postInStorageKey,
  cardStoryId,
}: UsePostInStoryIdDefaultArgs) => {
  const { pathname } = useLocation();

  const [searchParams] = useSearchParams();

  const routeStoryId = Number(useParams().storyId);

  if (cardStoryId) {
    return cardStoryId;
  }

  const items = `${routeStoryId}/items`;

  const routes = [
    `/storyTab1/${items}`,
    `/storyTab2/${items}`,
    `/storyTab3/${items}`,
    `/storyTab4/${items}`,
    `/storyTab5/${items}`,
    `/pinnedStoryTab/${items}`,
    `/pinnedStoryTab2/${items}`,
    `/pinnedStoryTab3/${items}`,
    `/pinnedStoryTab4/${items}`,
    `/pinnedStoryTab5/${items}`,
    `/admin/storyTab/${items}`,
    `/admin/storyTab1/${items}`,
    `/admin/storyTab2/${items}`,
    `/admin/storyTab3/${items}`,
    `/admin/storyTab4/${items}`,
    `/admin/storyTab5/${items}`,
    `/admin/pinnedStoryTab/${items}`,
    `/admin/pinnedStoryTab2/${items}`,
    `/admin/pinnedStoryTab3/${items}`,
    `/admin/pinnedStoryTab4/${items}`,
    `/admin/pinnedStoryTab5/${items}`,
  ];

  const urlStoryId = Number(searchParams.get('storyId')) || undefined;

  const id = routes.includes(pathname)
    ? routeStoryId
    : urlStoryId ?? parseInt(localStorage.getItem(postInStorageKey) ?? '', 10);

  if (postInStories.find((postInStory) => postInStory.id === id)) {
    return id;
  }

  return postInStories[0]?.id;
};
